export default "__VITE_ASSET__3aa3828e__"